import React, { FC, useState } from 'react';
import { ReactComponent as UnassignRiderIcon } from 'assets/icons/unassign-rider-modal-icon.svg';
import { toast } from 'react-toastify';
import { BaseModal, Button, ToastMessage } from '@cokitchen/cokitchen-components';
import { OrderType } from 'models/order.model';
import { apiService } from 'utils/api';
import { getUserName } from 'utils/functions';
interface UnassignRiderModalProps {
  show: boolean;
  onClose: () => void;
  order: OrderType;
}

interface UnassignRiderFooterProps {
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const UnassignRiderFooter: FC<UnassignRiderFooterProps> = ({ onCancel, onConfirm, loading }) => (
  <div className='grid grid-cols-2 gap-x-4'>
    <Button small color='primary' variant='outline' className='mx-auto' onClick={onCancel}>
      Cancel
    </Button>
    <Button
      small
      color='primary'
      variant='block'
      className='mx-auto'
      loading={loading}
      onClick={onConfirm}>
      Confirm
    </Button>
  </div>
);

const UnassignRiderModal: FC<UnassignRiderModalProps> = ({ show, onClose, order }) => {
  const [loading, setLoading] = useState(false);

  const unassignRider = async () => {
    try {
      setLoading(true);
      await apiService.post('logistics/order/rider/unassign', {
        data: {
          order_id: order.id
        },
        baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
      });
      toast(<ToastMessage type='success' message='Unassign successful' />);
      onClose();
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };

  return (
    <BaseModal
      isOpen={show}
      title='Unassign Rider'
      description={`Are you sure you want to unassign ${getUserName(order.rider)} for order #${
        order?.order_code?.toUpperCase() ?? ''
      }`}
      titleIcon={<UnassignRiderIcon />}
      titleIconColor='danger'
      onRequestClose={onClose}
      footer={
        <UnassignRiderFooter loading={loading} onCancel={onClose} onConfirm={unassignRider} />
      }
    />
  );
};

export default UnassignRiderModal;
